import { detect } from "detect-browser";

export default () => {
    if (window && window.navigator) {
        const browser = detect();

        return browser && browser.name;
    }

    return false;
};
